module.exports = {
    nameValid: /^[a-zA-Z' ]{0,}$/,
    namehypenValid: /^[a-zA-Z0-9' -_]+$/,
    emailValid: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    passwordValid: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&!?.*])[0-9a-zA-Z@#$%^&!?.*]{8,}$/,
    IFSCCodeValid: /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
    numberValid: /^[0-9]*$/,
    faxValid: /^\+?[0-9]{7,}$/,
    numbersonlyValid: /^[0-9\b]+$/,
    alphanumericValid: /^[a-z0-9]+$/i,
    alphanumcommaValid: /^[0-9,]+$/,
    isValidWebsiteName: /^((([0-9]{1,3}\.){3}[0-9]{1,3})|(([a-zA-Z0-9]+(([\-]?[a-zA-Z0-9]+)*\.)+)*[a-zA-Z]{2,}))$/,
    isMultipleTelNo: /^[0-9,()+]+$/,
    GST_REG_EXP: /^([0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9a-zA-Z]{1})|([0-9]{4}[A-Z]{3}[0-9]{5}[UO]{1}[N][A-Z0-9]{1})|([0-9]{2}[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}[0-9]{1}[Z]{1}[0-9]{1})|([0-9]{4}[a-zA-Z]{3}[0-9]{5}[N][R][0-9a-zA-Z]{1})|([0-9]{2}[a-zA-Z]{4}[a-zA-Z0-9]{1}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[D]{1}[0-9a-zA-Z]{1})|([0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[C]{1}[0-9a-zA-Z]{1})|([9][9][0-9]{2}[a-zA-Z]{3}[0-9]{5}[O][S][0-9a-zA-Z]{1})$/,
    companyName_Exp:/^([a-zA-Z0-9]{1,})[a-zA-Z'\-\. ]{0,}$/
}